import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { MaintenanceTaskDTO } from '../maintenance-task-dto';
import { UserService } from '../../services/user.service';
import { MaintenanceService } from '../maintenance.service';
import { MaintenanceTask } from '../maintenance/MaintenanceTask.model';

@Component({
    selector: 'app-add-maintenance-task-modal',
    templateUrl: './add-maintenance-task-modal.component.html',
    styleUrls: ['./add-maintenance-task-modal.component.scss'],
    standalone: false
})
export class AddMaintenanceTaskModalComponent implements OnInit {
    @Input() maintenanceTask: MaintenanceTask | null = null;

    public maintenanceTaskDTO: MaintenanceTaskDTO = new MaintenanceTaskDTO();
    public maintenanceTaskCategories: any[] = [];

    constructor(
        private readonly modalCtrl: ModalController,
        private readonly userService: UserService,
        private readonly toastController: ToastController,
        private readonly maintenanceService: MaintenanceService
    ) {
        this.maintenanceTaskDTO.periodNumber = 1;
        this.maintenanceTaskDTO.periodType = 'WEEK';
        this.maintenanceTaskDTO.maintenanceTaskCategoryId = 1;
    }

    public async ngOnInit() {
        await this.getMaintenanceTaskCategories();
        if (this.maintenanceTask) {
            this.maintenanceTaskDTO = MaintenanceTaskDTO.createFromMaintenanceTask(this.maintenanceTask);
        } else {
        }
    }

    public cancel() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    public async getMaintenanceTaskCategories() {
        this.maintenanceTaskCategories = await this.maintenanceService.getAllMaintenanceTaskCategories();
        // If the show has no categories yet, the constructor's default
        // categoryId of 1 would point at a row that doesn't exist for this
        // show and the backend would reject the create with 400. Clear it
        // so the DTO sends 0 (skipped server-side) and the form lets the
        // user save without a category.
        if (this.maintenanceTaskCategories.length === 0) {
            this.maintenanceTaskDTO.maintenanceTaskCategoryId = 0;
        }
    }

    public async confirm() {
        if (
            !this.maintenanceTaskDTO.name ||            this.maintenanceTaskDTO.name?.trim() === ''
        ) {
            const toast = await this.toastController.create({
                message: 'Vul een naam voor de onderhoudstaak in',
                duration: 2000,
                color: 'danger'
            });
            await toast.present();
            return;
        }
        if (
            this.maintenanceTaskDTO.periodNumber < 1 ||            this.maintenanceTaskDTO.periodNumber % 1 !== 0
        ) {
            const toast = await this.toastController.create({
                message: 'De periode mag niet negatief, 0 of decimaal zijn',
                duration: 2000,
                color: 'danger'
            });
            await toast.present();
            return;
        }

        try {

            this.maintenanceTaskDTO.createdById =                await this.userService.getActiveUserId();

            if (!this.maintenanceTask) {
                const response = await this.maintenanceService.createMaintenanceTask(
                    this.maintenanceTaskDTO
                );
                return this.modalCtrl.dismiss(response, 'confirm');
            }
                const response = await this.maintenanceService.updateMaintenanceTask(
                    this.maintenanceTaskDTO,
                    this.maintenanceTask.id
                );
                return this.modalCtrl.dismiss(response, 'confirm');

        } catch (e) {
            console.error(e);
            const toast = await this.toastController.create({
                message: 'Er ging iets mis met het opslaan. Probeer het later nog eens of contacteer Roy.',
                duration: 2000,
                color: 'danger'
            });
            await toast.present();
        }

    }
}
